import { Button, ButtonGroup } from "@chakra-ui/react";
import { t } from "i18next";
import { CommentCreator } from "../inputs/CommentCreator";
import { useState } from "react";

interface Props {
  craWayId: string;
}
export const AddGeneralComment: React.FC<Props> = ({ craWayId }) => {
  const [showCommentCreator, setShowCommentCreator] = useState(false);

  return showCommentCreator ? (
    <CommentCreator
      craWayId={craWayId}
      onClose={() => setShowCommentCreator(false)}
    />
  ) : (
    <ButtonGroup alignSelf="end">
      <Button
        colorPalette="primary"
        size="sm"
        onClick={() => setShowCommentCreator(true)}
      >
        {t("map:wayComments.addBtn")}
      </Button>
    </ButtonGroup>
  );
};
